export default "__VITE_ASSET__Bf29IWnt__"